import { Button, ButtonProps } from "@mui/material";
import { FunctionComponent } from "react";

interface IStyledButtonProps {
  spacing?: number;
  ml?: string;
  disabled?: boolean;
}

export const StyledButton: FunctionComponent<
  ButtonProps & IStyledButtonProps
> = ({ children, ml, spacing = 2, sx, ...rest }) => {
  return (
    <Button
    disabled={rest.disabled}
      sx={{
        minWidth: "100px !important",
        padding: "6px 16px !important",
        borderRadius: "4px !important",
        marginLeft: ml ? ml: "8px !important",
        backgroundColor: "var(--kyocera-blue)",
        textTransform: "unset",
        color: "var(--kyocera-white)",
        "& span.MuiButton-label": {
          textTransform: "none",
          whiteSpace: "nowrap",
        },
        '&:hover': {
          backgroundColor: "var(--kyocera-blue)",
          color: "var(--kyocera-white)",
          boxShadow: [
            "0px 2px 2px 0px rgba(0,0,0,0.14)",
            "0px 1px 5px 0px rgba(0,0,0,0.12)",
          ].join(","),
        },
        "&.Mui-disabled": {
          opacity: 0.5,
          backgroundColor: "var(--kyocera-background-grey)",
          color: "var(--kyocera-dark-grey)",
        },
        "&.MuiButton-containedLight": {
          backgroundColor: "var(--kyocera-cp-background-grey)",
          color: "var(--kyocera-dark-grey)",
        },
        "&.MuiButton-contained": {
          backgroundColor: "var(--kyocera-text-grey)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedPrimary": {
          backgroundColor: "var(--kyocera-blue)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedSecondary": {
          backgroundColor: "var(--kyocera-text-grey)",
          color: "var(--kyocera-white)",
        },
        "&.MuiButton-containedActionWhite": {
          backgroundColor: "var(--kyocera-white)",
          color: "var(--kyocera-text-grey)",
        },
        "&.MuiButton-ActionPrimary": {
          "@extend": ".MuiButton-containedPrimary",
          "&.Mui-disabled": {
          "@extend": ".MuiButton-containedActionWhite",
          }
        },
        "&.MuiButton-containedError": {
          backgroundColor: "var(--important-red)",
          color: "var(--kyocera-white)",
        },
        "&.non-tranform": {
         textTransform: "none"
        },
        ...sx
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};
